import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";


export const GetDriveActivityService=async(page,text,from_date,to_date)=>{
    try {
        const result = await get(`api/folder_activity/get?page=${page}&search=${text}&from_date=${from_date}&to_date=${to_date}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateDriveActivityService=async(data)=>{
    try {
        const result = await post(`api/folder_activity/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateDriveActivityService=async(data,id)=>{
    try {
        const result = await put(`api/folder_activity/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteDriveActivityService=async(id)=>{
    try {
        const result = await deleteRequest(`api/folder_activity/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}
